import React from 'react';
import Anchor from '@sdtech/sd-ui/Anchor';

function ErrorFragment() {
  return (
    <div>
      <h3 className="u-clr-white">Sorry, we seem to have hit a problem processing your request</h3>
      <p className="u-padding-m-top">
        You could try reloading the page, or perhaps leave it a few
        minutes then try again. If that doesn’t solve the problem,
        our
        {' '}
        <Anchor href="https://service.elsevier.com/app/contact/supporthub/sciencedirect/" className="u-clr-orange">support team</Anchor>
        {' '}
        will be
        happy to help.
      </p>
    </div>
  );
}

export default ErrorFragment;
